<template>
  <v-container class="pt-0" fluid>
    <v-row align="center">
      <v-col cols="12">
        <data-table :items="items" :loading="loading" @rechargeTable="getAllImportacoes()" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import pusherMixins from '@/mixins/pusherMixins';
  import importacoesSpedService from '@/services/importacoesSpedService';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      DataTable: () => import('@/components/importacoesSped/Table.vue')
    },
    mixins: [pusherMixins, tourMixins],

    data: () => ({
      items: [],
      loading: false,
      arrTour: [
        {
          element: '#btn-nova-importacao-sped',
          intro: 'Clicando neste botão você poderá criar novas Importação de Sped.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#importacao-sped-search',
          intro: 'Neste campo você poderá pesquisar por Importação de Sped já existentes.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#action-excluir-importacao-sped',
          intro: 'Clicando neste ícone você poderá excluir a Importação de Sped.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#action-download-importacao-sped',
          intro: 'Clicando neste ícone você poderá editar a importação de Sped.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#action-detalhes-importacao-sped',
          intro: 'Aqui você vizualizar mais detalhes dos arquivos da Importação de Sped.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ]
    }),

    created() {
      this.getAllImportacoes();
      this.subscribe();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('reload-pag-sped', () => {
          this.getAllImportacoes();
        });
      },

      getAllImportacoes() {
        this.loading = true;

        importacoesSpedService
          .getAllImportacoes()
          .then((resp) => {
            this.items = resp.data.data;
          })
          .catch((err) => {
            this.$toast.error('Erro ao recuperar as Importações de SPED.', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => {
            ((this.loading = false), this.iniciarTourPagina());
          });
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;

        let arrTourFormatted = this.items.length ? this.arrTour : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      }
    }
  };
</script>